import { SVG, SVGProps } from './svg'

export function IconHamburger(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M20.5 7h-17a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h17c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zm.5 5.5v-1c0-.3-.2-.5-.5-.5h-17c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h17c.3 0 .5-.2.5-.5zm0 5v1c0 .3-.2.5-.5.5h-17a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h17c.3 0 .5.2.5.5z" />
    </SVG>
  )
}
